import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LotList } from '../../../shared/entities/LotList';
import { LoggingService } from '../helper/log.service';
import { QuickSearchResults } from '../../../shared/entities/QuickSearchResults';
import { PaymentTypes } from '../../../shared/entities/PaymentTypes';
import { InvoiceService } from './invoice.service';
import { InvoiceAdjustmentReasons } from '../../../shared/entities/InvoiceAdjustmentReasons';



const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};

@Injectable()
  export class AdjustmentService {
    paymentTypes: PaymentTypes[] = [];
    invoiceAdjustmentReasons: InvoiceAdjustmentReasons [] = [];

    constructor(
        private http: HttpClient,
        private invoiceService: InvoiceService
      ) {
        this.initAdjustmentService();
      }

    
    initAdjustmentService(): void{
        this.paymentTypes = [];
        this.invoiceAdjustmentReasons = [];
    }

    setPaymentTypesForLot(lotNumber: string): void{
        this.getPaymentTypesForLotNumberFromDB(lotNumber);
    }

    setInvoiceAdjustmentReasonsForLotNumber(lotNumber: string): void{
      this.getInvoiceAdjustmentReasonsForLotNumberFromDB(lotNumber);
    }

    getCurrentLotPaymentTypes(): PaymentTypes[]{
        return this.paymentTypes;
    }

    getCurrentLotAdjustmentReasons(): InvoiceAdjustmentReasons[]{
        return this.invoiceAdjustmentReasons;
    }

    private getPaymentTypesForLotNumberFromDB(lotNumber: string): void{
        this.invoiceService.getPaymentTypesForLotNumber(lotNumber, 'adjustment.services.ts-getPaymentsTypeForLotNumberForDB()').subscribe(
          paymentTypeList => {
            this.paymentTypes = paymentTypeList
          },
          (err:any) => {
          },
          () => {
            let aPaymentType: PaymentTypes = new PaymentTypes();
            aPaymentType.paymentCode = '0';
            aPaymentType.paymentDescription = '-- SELECT PAYMENT TYPE --';
            this.paymentTypes.splice(0,0, aPaymentType);
          }
        )
    }

    private getInvoiceAdjustmentReasonsForLotNumberFromDB(lotNumber: string): void{
      this.invoiceService.getAdjustmentReasonsForLotNumber(lotNumber).subscribe(
        invoiceAdjustmentReasons => {
          this.invoiceAdjustmentReasons = invoiceAdjustmentReasons
        },
        (err:any) => {
        },
        () => {
      
        }
      )
    }

}